Vendd.Scripts.load(function () {

    if ($('.header-template-one').length <= 0)
        return;

    if (isTouch()) {
        initResponsiveHeader();
        //initScrollDirection();
        stickyHeaderResponsive();
    } else {
        stickyHeader();
    }

    initCallMeBack();
    initUspSlider();

    var isMoved = false;
});

function stickyHeader() {
    var header = $('.header-region');
    var spacer = $('.header-spacer');
    var inlineAdminHeight, eSatisfactionHeight, infoBarHeight, mainBarHeight;

    initSticky();
    $(window).scroll(initSticky);
    $(window).resize(function () { initSticky() });

    function initSticky() {

        if ($('html').hasClass('no-scroll')) return;

        infoBarHeight = $('.region-area-one', header).height();
        mainBarHeight = $('.region-area-two', header).height();
        inlineAdminHeight = $('.region-area-zero', header).height() || 0;
        eSatisfactionHeight = $('.esat-bar').height() || 0;

        if (($(window).scrollTop() < infoBarHeight + inlineAdminHeight + eSatisfactionHeight || $(window).outerWidth() < 1200)) {
            header.removeClass('sticky');
            spacer.height(0);
        } else {
            header.addClass('sticky');
            spacer.height(mainBarHeight); 
        }
    }    
}

function stickyHeaderResponsive() {
    var header = $('.header-region');
    var spacer = $('.header-spacer');
    var inlineAdminHeight, eSatisfactionHeight, infoBarHeight, mainBarHeight, searchBarHeight;
    
    initStickyResponsive();
    $(window).scroll(initStickyResponsive);
    $(window).resize(function () { initStickyResponsive() });

    function initStickyResponsive() {

        if ($('html').hasClass('no-scroll')) return;

        infoBarHeight = $('.region-area-one', header).height();
        mainBarHeight = $('.region-area-two', header).height();
        searchBarHeight = $('.region-area-three', header).height();
        inlineAdminHeight = $('.region-area-zero', header).height() || 0;
        eSatisfactionHeight = $('.esat-bar').height() || 0;

        if (($(window).scrollTop() <= infoBarHeight + inlineAdminHeight + eSatisfactionHeight)) {
            header.removeClass('sticky');
            spacer.height(0);
        } else {
            header.addClass('sticky');
            if ($(window).outerWidth() < 1200) {
                spacer.height(mainBarHeight + searchBarHeight);
            } else {
                spacer.height(mainBarHeight);
            }
        }      
    }  
}

function initResponsiveHeader() {

    if (isTouch()) {
        $(window).resize(function () {
            attachToResponsiveArea();
        });
    }

    var isMoved = false;

    if ($(window).outerWidth() < 1200) {
        if (isTouch()) {
            $('.header-region .region-area-two').addClass('reveal');
            $('.header-region .region-area-three').addClass('reveal');
            $('.header-region .x-searchbox').detach().appendTo('.header-region .region-area-three');
            isMoved = true;
        }
    }

    function attachToResponsiveArea() {

        if ($(window).outerWidth() < 1200) {
            if (!isMoved) {
                $('.header-region .region-area-two').addClass('reveal');
                $('.header-region .region-area-three').addClass('reveal');
                $('.header-region .x-searchbox').detach().appendTo('.header-region .region-area-three');
                isMoved = true;
            }
        } else {
            if (isMoved) {
                $('.header-region .x-searchbox').detach().insertAfter('.header-region .region-area-two .x-menu.main-menu');
                isMoved = false;
            }
        }
    }
}

function initScrollDirection() {
    var header = $('.header-region');
    var previousScroll = 0;

    $(window).scroll(function () {
        var currentScroll = $(this).scrollTop();
        if (currentScroll > previousScroll) {
            if (currentScroll > header.height()) {
                header.addClass('scroll-down').removeClass('scroll-up');
            }
        } else {
            header.addClass('scroll-up').removeClass('scroll-down');
        }
        previousScroll = currentScroll;
    });

}

function initCallMeBack() {

    if ($('.x-call-me-back-widget').length < 1)
        return;

    $('.call-me-back').click(function (e) {
        var url = $(this).data('url');
        $.fancybox.open({
            src: url,
            type: "iframe",
            toolbar: false,
            smallBtn: true,
            hash: null,
            baseClass: 'call-me-back-fancy',
            afterShow: function () {
                var $iframe = $('.fancybox-iframe').contents();
                $iframe.find('body').addClass('full');
            }
        });

    });
}

function initUspSlider() {
    var $header = $('.header-region');
    var $usps = $('.x-usp-widget', $header);

    if ($usps.length < 1) return;

    var ww = $(window).outerWidth();
    var mobile = (ww < 960) ? true : false;

    if (mobile) {
        var uspSlider = new Swiper(".x-usp-widget", {
            slidesPerView: 1,
            autoplay: {
                delay: 4000,
            },
            speed: 1000
        });
    }

    $(window).on('resize', function () {
        ww = $(window).outerWidth();
        mobile = (ww < 960) ? true : false;

        if (mobile) {
            if (!$usps.hasClass('swiper-initialized')) {
                uspSlider = new Swiper(".x-usp-widget", {
                    slidesPerView: 1,
                    autoplay: {
                        delay: 4000,
                    },
                    speed: 1000
                });
            }
        } else {
            if ($usps.hasClass('swiper-initialized')) {
                uspSlider.destroy(true, true);
                $('.swiper-wrapper', $usps).removeAttr('style');
                $('.swiper-slide', $usps).removeAttr('style');
            }
        }
    });

}

function calculateSearchHeight() {
    var $wrapper = $('.x-searchbox.elastic');

    if ($wrapper.length < 1) return;

    var header = $('.header-region');
    var headerHeight, regionHeight, eSatisfactionHeight, searchOffset;

    //header height
    headerHeight = header.height() || 0;
    regionHeight = $('.region-area-four', header).height() || 0;
    headerHeight = headerHeight - regionHeight;
    //esatisfaction height
    eSatisfactionHeight = $('.esat-bar').height() || 0;
    //search offset
    searchOffset = headerHeight + eSatisfactionHeight;


    $('.x-elastic-results-list', $wrapper).css({ 'height': 'calc(100% - ' + searchOffset + 'px)', top: searchOffset });
}




